module.exports = __webpack_public_path__ + "GEM-AWARDS-2025-751611da.webp";